import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Interweave from 'interweave';
import * as StyledClause from './clause.styles';
import { CheckBoxWrapper, CheckBox, CheckBoxLabel } from '../../base/forms/checkBox';
import {
	Button
} from '../../base';

const Clause = ({
	content,
	buttonText,
	onAccept
}) => {
	const [isChecked, setIsChecked] = useState(false);

	const onCheckboxChange = () => {
		setIsChecked(!isChecked);
	};

	const onContinueClick = () => {
		if(isChecked) {
			onAccept();
		}
	};

	return (
		<StyledClause.Wrapper>
			<Interweave content={content} />
			<StyledClause.CheckBoxWrapper>
				<CheckBoxWrapper checked={isChecked} onClick={onCheckboxChange}>
					<div>
						<CheckBox id="accept-terms" checked={isChecked} />
						<CheckBoxLabel htmlFor="accept-terms">
							<span>{buttonText}</span>
						</CheckBoxLabel>
					</div>
				</CheckBoxWrapper>
			</StyledClause.CheckBoxWrapper>
			<StyledClause.ButtonWrapper>
				<Button onClick={onContinueClick} primary large disabled={!isChecked}>
					<span>Áfram</span>
				</Button>
			</StyledClause.ButtonWrapper>
		</StyledClause.Wrapper>
	);
};

Clause.propTypes = {
	content: PropTypes.string,
	onAccept: PropTypes.func.isRequired
};

Clause.defaultProps = {
	content: ''
};

export default Clause;
